import { API_SERVER,API_PROXY_SERVER } from 'config/constant';
import { getMethod, postMethod, putMethod ,urls,postMethodfile,postVoice} from 'utils/url/urls';
const person = localStorage.getItem('user');
const user = JSON.parse(person);

export async function addgame(data) {
  try {
    const person = localStorage.getItem('user');
    const user = JSON.parse(person);    
    const response = await fetch(`${API_SERVER}${urls.addgame}`, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: user?.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const result = await response.json(); 
    return result;
  } catch (err) {
    console.log('addgame Error:', err); 
  }
} 
export async function getPreview(id) {
  try {
    const response = await fetch(`${API_SERVER}${urls.getpreview}${id}`,getMethod());
    const result = await response.json(); 
    return result;
  } catch (err) {
    console.log('getPreview Error:', err);
  }
}

  export async function storeRefqes(data){
  try {
    const response = await fetch(
      `${API_SERVER}${urls.storeRefQes}`,
      postMethod(data)
    );
    return await response.json();
  } catch (err) {
    console.log("storeRefqes Error:", err.message);
  }
}
  export async function storeRefqes1(data2){
  try {
    const response = await fetch(
      `${API_SERVER}${urls.storeRefQes1}`,
      postMethod(data2)
    );
    return await response.json();
  } catch (err) {
    console.log("storeRefqes Error:", err.message);
  }
}
export async function getAllGame(data,type) {
  try {
    const response = await fetch(`${API_SERVER}${urls.gameList}${type}`,putMethod(data));
    const result = await response.json(); 
    return result;
  } catch (err) {
    console.log('getAllGame Error:', err);
  }
}

export async function getImages(id){
    try { 
        const response = await fetch(`${API_SERVER}${urls.getImages}${id}`,getMethod());
        const result = await response.json();
        return result;
      }
    catch (err) {
        console.log('getImages Error:', err.message);
      }
}


export async function getAssignedGame(id){
    try{
        const response = await fetch(`${API_SERVER}${urls.getAssignedGames}/${id}`,getMethod());
        const result = await response.json();
        return result;
    }
    catch (err) {
        console.log('getAssignedGame Error:', err.message);
      }
  }
export async function getLearnerActivityDetails(id){
    try{
        const response = await fetch(`${API_SERVER}${urls.getLearnerActivityDetails}/${id}`,getMethod());
        const result = await response.json();
        return result;
    }
    catch (err) {
        console.log('getLearnerActivityDetails Error:', err.message);
      }
  }
export async function getLeaderboardData(id){
    try{
        const response = await fetch(`${API_SERVER}${urls.getLeaderboardData}${id}`,getMethod());
        const result = await response.json();
        return result;
    }
    catch (err) {
        console.log('getAssignedGame Error:', err.message);
      }
  }
  export async function overallScoreDetails(id){
    try{
        const response = await fetch(`${API_SERVER}${urls.overallScoreDetails}${id}`,getMethod());
        const result = await response.json();
        return result;
    }
    catch (err) {
        console.log('getScrore Error:', err.message);
      }
  }
  export async function getBackgrounds(){
    try{
        const response = await fetch(`${API_SERVER}${urls.getBackgrounds}`,getMethod());
        const result = await response.json();
        return result;
    }
    catch (err) {
        console.log('getBackgrounds Error:', err.message);
      }
  }
   
  export async function getGamePlay(id,selectLanguageId){
    try{
        const response = await fetch(`${API_SERVER}${urls.getgameplay}${id}/${selectLanguageId}`,getMethod());
        const result = await response.json();
        return result;
    }
    catch (err) {
        console.log('getBackgrounds Error:', err.message);
      }
  }
  export async function PlayerGamePlayDetails(id,selectedLanguages){
    try{
        const response = await fetch(`${API_SERVER}${urls.playergamePlay}${id}/${selectedLanguages}`,getMethod());
        const result = await response.json();
        return result;
    }
    catch (err) {
        console.log('getBackgrounds Error:', err.message);
      }
  }
  // export async function updateLearnerDetails(LearnerDataString) {
  //   try {
  //     const response = await fetch(`${API_SERVER}${urls.updateLearnerDetails}`,putMethod(LearnerDataString));
  //     const result = await response.json(); 
  //     return result;
  //   } catch (err) {
  //     console.log('getCreator Error:', err);
  //   }
  // }
  export async function getupdateLearnerDetails(LearnerDataString) {
  try {
    const response = await fetch(
      `${API_SERVER}${urls.getupdateLearnerDetails}`,
      putMethod(LearnerDataString)
    );

    // Always try to parse JSON if backend responds
    const result = await response.json();

    // ✅ Distinguish between success and business error
    if (!response.ok) {
      // HTTP error (4xx/5xx)
      return { success: false, error: result.message || "Request failed" };
    }

    // If backend explicitly sends failure like "no rows were updated"
    if (result?.message && result.message.includes("no rows")) {
      return { success: false, error: result.message };
    }

    // ✅ Normal success
    return { success: true, data: result };
  } catch (err) {
    // This only runs for true network errors (already filtered by wrapper)
    console.error("updateLearnerDetails fetch/network error:", err);
    return { success: false, error: "Network error" };
  }
}
  
  export async function updateLearnerDetails(LearnerDataString) {
  try {
    const response = await fetch(
      `${API_SERVER}${urls.updateLearnerDetails}`,
      putMethod(LearnerDataString)
    );

    // Always try to parse JSON if backend responds
    const result = await response.json();

    // ✅ Distinguish between success and business error
    if (!response.ok) {
      // HTTP error (4xx/5xx)
      return { success: false, error: result.message || "Request failed" };
    }

    // If backend explicitly sends failure like "no rows were updated"
    if (result?.message && result.message.includes("no rows")) {
      return { success: false, error: result.message };
    }

    // ✅ Normal success
    return { success: true, data: result };
  } catch (err) {
    // This only runs for true network errors (already filtered by wrapper)
    console.error("updateLearnerDetails fetch/network error:", err);
    return { success: false, error: "Network error" };
  }
}
//   export async function updateLearnerlogactivityDetails(LearnerDataString) {
//   try {
//     const response = await fetch(
//       `${API_SERVER}${urls.learnerActivityDetails}`,
//       putMethod(LearnerDataString)
//     );

//     // Always try to parse JSON if backend responds
//     const result = await response.json();

//     // ✅ Distinguish between success and business error
//     if (!response.ok) {
//       // HTTP error (4xx/5xx)
//       return { success: false, error: result.message || "Request failed" };
//     }

//     // If backend explicitly sends failure like "no rows were updated"
//     if (result?.message && result.message.includes("no rows")) {
//       return { success: false, error: result.message };
//     }

//     // ✅ Normal success
//     return { success: true, data: result };
//   } catch (err) {
//     // This only runs for true network errors (already filtered by wrapper)
//     console.error("learnerActivityDetails fetch/network error:", err);
//     return { success: false, error: "Network error" };
//   }
// }


export async function updateLearnerlogactivityDetails(LearnerDataString, retries = 0) {
  // const url = `${API_PROXY_SERVER}${urls.learnerActivityDetails}`;
  const url = `${API_SERVER}${urls.learnerActivityDetails}`;

  for (let attempt = 0; attempt <= retries; attempt++) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 20000); // give up after 20s, not 5 min

    try {
      const response = await fetch(url, {
        ...putMethod(LearnerDataString),
        signal: controller.signal,
      });
      clearTimeout(timeoutId);

      const result = await response.json();
      if (!response.ok) {
        return { success: false, error: result.message || "Request failed" };
      }
      return { success: true, data: result };

    } catch (err) {
      clearTimeout(timeoutId);
      console.error(`Attempt ${attempt + 1} failed:`, err.message);

      if (attempt === retries) {
        return { success: false, error: "Network error" };
      }
      await new Promise(r => setTimeout(r, 1000)); // wait 1 sec, try again
    }
  }
}
// export async function updateLearnerlogactivityDetails(LearnerDataString) {
//   try {
//     const url = `${API_SERVER}${urls.learnerActivityDetails}`;

//     console.log("========== learnerActivityDetails REQUEST ==========");
//     console.log("URL:", url);
//     console.log("Payload size:", new Blob([
//       typeof LearnerDataString === "string"
//         ? LearnerDataString
//         : JSON.stringify(LearnerDataString)
//     ]).size);

//     const response = await fetch(
//       url,
//       putMethod(LearnerDataString)
//     );

//     const result = await response.json();

//     if (!response.ok) {
//       return {
//         success: false,
//         error: result.message || "Request failed",
//       };
//     }

//     return {
//       success: true,
//       data: result,
//     };
//   } catch (err) {
//     console.error(
//       "learnerActivityDetails fetch/network error:",
//       err
//     );

//     return {
//       success: false,
//       error: "Network error",
//     };
//   }
// }
  export async function profileUpdate(data){
    try{
        const response = await fetch(`${API_SERVER}${urls.gameprofileUpdate}`,postMethod(data));
        const result = await response.json();
        return result;
    }
    catch (err) {
        console.log('getBackgrounds Error:', err.message);
      }
  }

  

  // export async function getVoices(id,data) {
  //   // try {
  //     const response = await fetch(`https://api.elevenlabs.io/v1/text-to-speech/${id}`,postVoice(data));
  //     const result = await response.json(); 
  //     console.log('result Error:', result);
  //     return result;
  //   // } catch (err) {
  //   //   console.log('getCreator Error:', err);
  //   // }
  // }
  export async function getLeaderBoard(id){
    try{
        const response = await fetch(`${API_SERVER}${urls.getleaderboard}${id}`,getMethod());
        const result = await response.json();
        return result;
    }
    catch (err) {
        console.log('getBackgrounds Error:', err.message);
      }
  }

  export async function getDashboard() {
    try {
      const response = await fetch(`${API_SERVER}${urls.gameDashboard}`, getMethod());
      const result = await response.json();
      return result;
    }
    catch (err) {
      console.log('dashboard Error:', err.message);
    }
  }
  export async function storeReflection(data){
    try{
        const response = await fetch(`${API_SERVER}${urls.storeReflection}`,postMethod(data));
        const result = await response.json();
        return result;
    }
    catch (err) {
        console.log('getBackgrounds Error:', err.message);
      }
  }

  export async function updateLearnerNickName(LearnerDataString) {
    try {
      const response = await fetch(`${API_SERVER}${urls.updateLearnerNickName}`,putMethod(LearnerDataString));
      const result = await response.json(); 
      return result;
    } catch (err) {
      console.log('getCreator Error:', err);
    }
  }



export async function ScenarioLearnerScore(payload) {
  try {
    const response = await fetch(
      `${API_SERVER}${urls.ScenarioLearnerScore}`,
      postMethod(JSON.stringify(payload)) // ✅ stringify here
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("API Error:", errorText);
      return null;
    }

    return await response.json();
  } catch (err) {
    console.error("ScenarioLearnerScore Error:", err);
    return null;
  }
}
// new
  export async function feedbackdata(data2){
  try {
    const response = await fetch(
      `${API_SERVER}${urls.feedbackdata}`,
      postMethod(data2)
    );
    return await response.json();
  } catch (err) {
    console.log("feedbackdata error", err.message);
  }
}


export async function ScenarioChange(id) {
  try {
    const response = await fetch(
      `${API_SERVER}${urls.ScenarioChange}/${id}`,
      postMethod() // ✅ stringify here
    );

    if (!response.ok) {
      const errorText = await response.text();
      console.error("API Error:", errorText);
      return null;
    }

    return await response.json();
  } catch (err) {
    console.error("ScenarioLearnerScore Error:", err);
    return null;
  }
}

 export async function updateLearnerMentorName(LearnerDataString) {
    try {
      const response = await fetch(`${API_SERVER}${urls.updateLearnerMentorName}`,putMethod(LearnerDataString));
      const result = await response.json(); 
      return result;
    } catch (err) {
      console.log('getCreator Error:', err);
    }
  }

    export async function getAverageScore(stringhistdata){
  try {
    const response = await fetch(
      `${API_SERVER}${urls.getAverageScore}`,
      postMethod(stringhistdata)
    );
    return await response.json();
  } catch (err) {
    console.log("getMinigame Score Error:", err.message);
  }
}